import React, { useState } from "react";
import "./TempTest.css";

const TempTest = () => {
  const [testResults, setTestResults] = useState({
    health: null,
    connection: null,
    tables: null,
    query: null,
    users: null,
    vipSchema: null,
    vipData: null,
  });

  const [loading, setLoading] = useState({
    health: false,
    connection: false,
    tables: false,
    query: false,
    users: false,
    vipSchema: false,
    vipData: false,
  });

  const [customQuery, setCustomQuery] = useState(
    "SELECT NOW() as current_time, VERSION() as mysql_version, DATABASE() as current_database"
  );
  const [apiUrl, setApiUrl] = useState("http://43.200.176.183:3001");

  // 로딩 상태 업데이트 함수
  const setLoadingState = (testType, isLoading) => {
    setLoading((prev) => ({ ...prev, [testType]: isLoading }));
  };

  // 결과 업데이트 함수
  const setTestResult = (testType, result) => {
    setTestResults((prev) => ({ ...prev, [testType]: result }));
  };

  // 1. Health Check
  const testHealth = async () => {
    setLoadingState("health", true);
    try {
      const response = await fetch(`${apiUrl}/health`);
      const result = await response.json();
      setTestResult("health", {
        success: response.ok,
        message: "서버 상태 확인 완료",
        data: result,
      });
    } catch (error) {
      setTestResult("health", {
        success: false,
        message: "서버 연결 실패",
        error: error.message,
      });
    }
    setLoadingState("health", false);
  };

  // 2. DB 연결 테스트
  const testConnection = async () => {
    setLoadingState("connection", true);
    try {
      const response = await fetch(`${apiUrl}/api/db-connect`);
      const result = await response.json();
      setTestResult("connection", {
        success: result.success,
        message: result.message,
        data: result,
      });
    } catch (error) {
      setTestResult("connection", {
        success: false,
        message: "네트워크 오류",
        error: error.message,
      });
    }
    setLoadingState("connection", false);
  };

  // 3. 테이블 조회 테스트
  const testTables = async () => {
    setLoadingState("tables", true);
    try {
      const response = await fetch(`${apiUrl}/api/tables`);
      const result = await response.json();
      setTestResult("tables", {
        success: result.success,
        message: result.message || "테이블 조회 완료",
        data: result.tables,
      });
    } catch (error) {
      setTestResult("tables", {
        success: false,
        message: "네트워크 오류",
        error: error.message,
      });
    }
    setLoadingState("tables", false);
  };

  // 4. 쿼리 실행 테스트
  const testQuery = async () => {
    setLoadingState("query", true);
    try {
      const response = await fetch(`${apiUrl}/api/query`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ query: customQuery }),
      });
      const result = await response.json();
      setTestResult("query", {
        success: result.success,
        message: result.message || "쿼리 실행 완료",
        data: result.results,
        error: result.error,
      });
    } catch (error) {
      setTestResult("query", {
        success: false,
        message: "네트워크 오류",
        error: error.message,
      });
    }
    setLoadingState("query", false);
  };

  // 5. 사용자 목록 조회 (예시 API)
  const testUsers = async () => {
    setLoadingState("users", true);
    try {
      const response = await fetch(`${apiUrl}/api/users`);
      const result = await response.json();
      setTestResult("users", {
        success: result.success,
        message: result.message || "사용자 목록 조회 완료",
        data: result.users,
      });
    } catch (error) {
      setTestResult("users", {
        success: false,
        message: "네트워크 오류",
        error: error.message,
      });
    }
    setLoadingState("users", false);
  };

  // 6. VIP11 스키마 조회 테스트
  const testVipSchema = async () => {
    setLoadingState("vipSchema", true);
    try {
      const response = await fetch(`${apiUrl}/api/vip11/schema`);
      const result = await response.json();
      setTestResult("vipSchema", {
        success: result.success,
        message: result.message || "VIP11 스키마 조회 완료",
        data: result.tables,
      });
    } catch (error) {
      setTestResult("vipSchema", {
        success: false,
        message: "네트워크 오류",
        error: error.message,
      });
    }
    setLoadingState("vipSchema", false);
  };

  // 7. VIP11 데이터 조회 테스트
  const testVipData = async () => {
    setLoadingState("vipData", true);
    try {
      const response = await fetch(`${apiUrl}/api/vip11/get-data`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          search: "",
          searchFields: ["data_id"], // 실제 테이블 구조에 맞게 수정
        }),
      });
      const result = await response.json();
      setTestResult("vipData", {
        success: result.success,
        message: result.message || "VIP11 데이터 조회 완료",
        data: result,
        error: result.error,
      });
    } catch (error) {
      setTestResult("vipData", {
        success: false,
        message: "네트워크 오류",
        error: error.message,
      });
    }
    setLoadingState("vipData", false);
  };

  // 전체 테스트
  const testAll = async () => {
    await testHealth();
    await testConnection();
    await testTables();
    await testUsers();
    await testVipSchema();
    await testVipData();
  };

  // 결과 렌더링 함수
  const renderResult = (result) => {
    if (!result) return null;

    return (
      <div className={`result ${result.success ? "success" : "error"}`}>
        <div className="result-header">
          <span
            className={`status-icon ${result.success ? "success" : "error"}`}
          >
            {result.success ? "✅" : "❌"}
          </span>
          <span className="message">{result.message}</span>
        </div>

        {result.data && (
          <div className="result-data">
            <pre>{JSON.stringify(result.data, null, 2)}</pre>
          </div>
        )}

        {result.error && (
          <div className="error-detail">
            <strong>오류 상세:</strong> {result.error}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="temp-test-container">
      <div className="header">
        <h1>EC2 백엔드 API 테스트</h1>
        <p>Node.js 백엔드 서버와 RDS 데이터베이스 연결을 테스트합니다.</p>
      </div>

      {/* API URL 설정 */}
      <div className="config-section">
        <label htmlFor="api-url">API URL:</label>
        <input
          id="api-url"
          type="text"
          value={apiUrl}
          onChange={(e) => setApiUrl(e.target.value)}
          placeholder="http://43.200.176.183:3001"
        />
        <small>
          EC2에서 백엔드 서버가 3001번 포트에서 실행 중입니다. (EC2 IP:
          43.200.176.183)
        </small>
      </div>

      {/* 테스트 버튼들 */}
      <div className="test-section">
        <div className="test-grid">
          {/* 1. Health Check */}
          <div className="test-card">
            <h3>1. 서버 상태 확인</h3>
            <p>백엔드 서버가 정상적으로 실행 중인지 확인합니다.</p>
            <button
              onClick={testHealth}
              disabled={loading.health}
              className="test-button"
            >
              {loading.health ? "확인 중..." : "Health Check"}
            </button>
            {renderResult(testResults.health)}
          </div>

          {/* 2. DB 연결 테스트 */}
          <div className="test-card">
            <h3>2. RDS 연결 테스트</h3>
            <p>데이터베이스 서버에 연결할 수 있는지 확인합니다.</p>
            <button
              onClick={testConnection}
              disabled={loading.connection}
              className="test-button"
            >
              {loading.connection ? "테스트 중..." : "연결 테스트"}
            </button>
            {renderResult(testResults.connection)}
          </div>

          {/* 3. 테이블 조회 테스트 */}
          <div className="test-card">
            <h3>3. 테이블 정보 조회</h3>
            <p>데이터베이스의 테이블 목록을 조회합니다.</p>
            <button
              onClick={testTables}
              disabled={loading.tables}
              className="test-button"
            >
              {loading.tables ? "조회 중..." : "테이블 조회"}
            </button>
            {renderResult(testResults.tables)}
          </div>

          {/* 4. 사용자 목록 조회 */}
          <div className="test-card">
            <h3>4. 사용자 목록 조회</h3>
            <p>users 테이블의 데이터를 조회합니다.</p>
            <button
              onClick={testUsers}
              disabled={loading.users}
              className="test-button"
            >
              {loading.users ? "조회 중..." : "사용자 조회"}
            </button>
            {renderResult(testResults.users)}
          </div>

          {/* 5. 쿼리 실행 테스트 */}
          <div className="test-card">
            <h3>5. 쿼리 실행 테스트</h3>
            <p>사용자 정의 SELECT 쿼리를 실행합니다.</p>

            {/* 쿼리 샘플 버튼들 */}
            <div className="query-samples" style={{ marginBottom: "10px" }}>
              <small>샘플 쿼리:</small>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "5px",
                  marginTop: "5px",
                }}
              >
                <button
                  type="button"
                  onClick={() =>
                    setCustomQuery(
                      "SELECT NOW() as current_time, VERSION() as mysql_version, DATABASE() as current_database"
                    )
                  }
                  style={{ fontSize: "12px", padding: "4px 8px" }}
                >
                  시스템 정보
                </button>
                <button
                  type="button"
                  onClick={() =>
                    setCustomQuery(
                      "SELECT TABLE_NAME, TABLE_ROWS, ENGINE FROM information_schema.TABLES WHERE TABLE_SCHEMA = DATABASE() ORDER BY TABLE_NAME"
                    )
                  }
                  style={{ fontSize: "12px", padding: "4px 8px" }}
                >
                  테이블 목록
                </button>
                <button
                  type="button"
                  onClick={() =>
                    setCustomQuery(
                      "SELECT ROUND(SUM(DATA_LENGTH + INDEX_LENGTH) / 1024 / 1024, 1) as DB크기_MB FROM information_schema.TABLES WHERE TABLE_SCHEMA = DATABASE()"
                    )
                  }
                  style={{ fontSize: "12px", padding: "4px 8px" }}
                >
                  DB 크기
                </button>
                <button
                  type="button"
                  onClick={() =>
                    setCustomQuery(
                      "SELECT CONCAT('Hello', ' ', 'World') as 문자열연결, UPPER('test') as 대문자, ROUND(3.14159, 2) as 반올림, RAND() as 랜덤수"
                    )
                  }
                  style={{ fontSize: "12px", padding: "4px 8px" }}
                >
                  함수 테스트
                </button>
              </div>
            </div>

            <div className="query-input">
              <textarea
                value={customQuery}
                onChange={(e) => setCustomQuery(e.target.value)}
                placeholder="SELECT * FROM your_table LIMIT 5"
                rows="4"
              />
            </div>
            <button
              onClick={testQuery}
              disabled={loading.query}
              className="test-button"
            >
              {loading.query ? "실행 중..." : "쿼리 실행"}
            </button>
            {renderResult(testResults.query)}
          </div>

          {/* 6. VIP11 스키마 조회 */}
          <div className="test-card">
            <h3>6. VIP11 스키마 조회</h3>
            <p>VIP 프로젝트 11 관련 데이터베이스 테이블 구조를 확인합니다.</p>
            <button
              onClick={testVipSchema}
              disabled={loading.vipSchema}
              className="test-button"
              style={{ backgroundColor: "#9c27b0", color: "white" }}
            >
              {loading.vipSchema ? "조회 중..." : "VIP11 스키마 조회"}
            </button>
            {renderResult(testResults.vipSchema)}
          </div>

          {/* 7. VIP11 데이터 조회 */}
          <div className="test-card">
            <h3>7. VIP11 데이터 조회</h3>
            <p>VIP 프로젝트 11의 환자 데이터를 조회합니다.</p>
            <button
              onClick={testVipData}
              disabled={loading.vipData}
              className="test-button"
              style={{ backgroundColor: "#673ab7", color: "white" }}
            >
              {loading.vipData ? "조회 중..." : "VIP11 데이터 조회"}
            </button>
            {renderResult(testResults.vipData)}
          </div>

          {/* 8. 전체 테스트 */}
          <div className="test-card full-width">
            <h3>8. 종합 테스트</h3>
            <p>모든 API 엔드포인트를 순차적으로 테스트합니다.</p>
            <button
              onClick={testAll}
              disabled={Object.values(loading).some((l) => l)}
              className="test-button primary"
            >
              {Object.values(loading).some((l) => l)
                ? "테스트 중..."
                : "전체 테스트 실행"}
            </button>
          </div>
        </div>
      </div>

      {/* 서버 정보 */}
      <div className="info-section">
        <h3>📌 API 엔드포인트 정보</h3>

        <h4>🔧 기본 테스트 API</h4>
        <ul>
          <li>
            <code>GET /health</code> - 서버 상태 확인
          </li>
          <li>
            <code>GET /api/db-connect</code> - DB 연결 테스트
          </li>
          <li>
            <code>GET /api/tables</code> - 테이블 목록 조회
          </li>
          <li>
            <code>GET /api/users</code> - 사용자 목록 조회
          </li>
          <li>
            <code>POST /api/query</code> - 커스텀 쿼리 실행
          </li>
        </ul>

        <h4>🏥 VIP11 프로젝트 API (Lambda 대체)</h4>
        <ul>
          <li>
            <code>GET /api/vip11/schema</code> - VIP11 테이블 스키마 조회
          </li>
          <li>
            <code>POST /api/vip11/get-data</code> - VIP11 환자 데이터 조회
          </li>
          <li>
            <code>POST /api/vip11/user-value</code> - VIP11 사용자 정보 조회
          </li>
          <li>
            <code>POST /api/vip11/save</code> - VIP11 폼 데이터 저장
          </li>
        </ul>

        <div
          style={{
            marginTop: "1rem",
            padding: "1rem",
            backgroundColor: "#e3f2fd",
            borderRadius: "8px",
            fontSize: "14px",
          }}
        >
          <strong>💡 다음 단계:</strong>
          <br />
          1. VIP11 스키마 조회로 실제 테이블 구조 확인
          <br />
          2. 테이블 구조에 맞게 VIP11 API 코드 조정
          <br />
          3. 프론트엔드 api.js를 VIP11 엔드포인트로 업데이트
          <br />
          4. 11SubjectList에서 새로운 VIP11 API 테스트
        </div>
      </div>
    </div>
  );
};

export default TempTest;
